import { Grid } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";

interface PhysicalExamNotesViewerProps {
  notes: string;
}

export default function PhysicalExamNotesViewer({ notes }: PhysicalExamNotesViewerProps) {
  return (
    <Grid mt="md" justify="flex-start">
      <Grid.Col span={{ base: 12, sm: 2 }}>
        <TextWrapper variant="bold">Notes</TextWrapper>
      </Grid.Col>
      <Grid.Col span={{ base: 12, sm: 10 }}>
        <TextWrapper>{notes}</TextWrapper>
      </Grid.Col>
    </Grid>
  );
}
